import { SocialLink } from '../lib/supabase';
import * as Icons from 'lucide-react';

type GetSocialSectionProps = {
  socialLinks: SocialLink[];
};

export default function GetSocialSection({ socialLinks }: GetSocialSectionProps) {
  const getIcon = (iconName: string) => {
    const Icon = Icons[iconName as keyof typeof Icons] as any;
    return Icon ? <Icon size={32} /> : <Icons.Link size={32} />;
  };

  return (
    <section className="py-20 bg-gradient-to-b from-black via-pink-900/20 to-black">
      <div className="container mx-auto px-4">
        <h2 className="font-horizon text-5xl md:text-7xl text-white text-center mb-6">
          Get Social & Connect
        </h2>

        <p className="text-center text-gray-300 text-lg mb-12 max-w-2xl mx-auto">
          Join the community on Discord, follow for updates, and stay connected across all platforms!
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 max-w-5xl mx-auto">
          {socialLinks.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-br from-purple-900/40 to-black border-2 border-purple-600/50 rounded-lg p-6 flex flex-col items-center justify-center hover-scale hover:border-yellow-400 transition-all group"
            >
              <div className="text-yellow-400 group-hover:text-yellow-300 mb-3 transition-colors">
                {getIcon(link.icon)}
              </div>
              <p className="font-semibold text-white group-hover:text-yellow-400 transition-colors text-center">
                {link.label}
              </p>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-block bg-gradient-to-r from-purple-600 to-pink-600 p-6 rounded-lg">
            <p className="text-white font-bold text-xl mb-2">
              Join the Discord Community!
            </p>
            <p className="text-gray-200 text-sm">
              The best place to connect with fellow indie devs and get real-time updates
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
